import(/* webpackPrefetch: 1 */ "@/views/ProductSelect");
import(/* webpackPrefetch: 2 */ "@/views/Census");
import(/* webpackPrefetch: 3 */ "@/views/Body");

import CopyRightFooter from "@/components/shared/CopyRightFooter";
import { Colors } from "@/components/shared/util";
import { navigationNamespace } from "@/store/modules/navigation";
import { userNamespace } from "@/store/modules/user";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({
  components: { CopyRightFooter }
})
export default class Login extends Vue {
  @Action("login", userNamespace)
  login!: Function;

  @Action("check", userNamespace)
  check!: Function;

  @Action("goHome", navigationNamespace)
  goHome!: Function;

  @Action("setArea", userNamespace)
  setArea!: Function;

  @Getter("route", navigationNamespace)
  route!: any;

  @Getter("isLoggedIn", userNamespace)
  isLoggedIn!: boolean;

  @Getter("areas", userNamespace)
  areas!: Array<string>;

  @Getter("demo", userNamespace)
  demo!: boolean;

  @Getter("inWrapper", navigationNamespace)
  inWrapper!: boolean;

  @Getter("darkMode", navigationNamespace)
  dark!: boolean;

  @Getter("system", userNamespace)
  systemInfo!: Record<string, any>;

  userID = "";
  password = "";

  domain = "";
  showPassword = false;
  phiSafeMode = false;
  submitting = false;

  lockIcon = "lock";

  get phiSafeLabel() {
    return "PHI safe mode: " + (this.phiSafeMode ? "On" : "Off");
  }

  get domains() {
    return this.systemInfo && this.systemInfo.windowsDomains;
  }

  get hasDomains() {
    return this.domains && this.domains.length > 1;
  }

  get blue() {
    return Colors.Blue;
  }

  errorMessages: Array<string> = [];
  submit() {
    this.submitting = true;
    this.errorMessages = [];
    const userID = encodeURIComponent(this.userID);
    const password = encodeURIComponent(this.password);
    const domain = this.domain;

    const loginData: any = {
      userID,
      password
    };

    if (this.phiSafeMode) {
      loginData.mask = true;
    }

    if (this.hasDomains) {
      loginData.windowsDomain = domain;
    }

    this.lockIcon = "lock_open";
    this.login(loginData).then(() => {
      this.submitting = false;
      if (this.isLoggedIn) {
        this.navigateToPreviousRouteOrProductSelect();
      } else {
        this.errorMessages.push("Incorrect User ID or password.");
        this.lockIcon = "lock";
      }
    });
  }

  // Redirect to route user tried to access before getting 401 and sent to login
  private navigateToPreviousRouteOrProductSelect() {
    const redirectTo = this.$store.getters["navigation/redirectTo"];
    if (redirectTo) {
      this.$store.dispatch("navigation/redirectTo", null);
      this.$router.push({ ...redirectTo });
    } else {
      this.$router.push({
        name: "productSelect"
      });
    }
  }

  checkField(value: string) {
    return !!value || "Required.";
  }

  @Watch("systemLoaded", { immediate: true })
  async initialize() {
    if (!this.systemLoaded) {
      return;
    }
    if (this.demo) {
      this.$router.push({
        name: "productSelect"
      });
      return;
    }
    await this.check();
    if (this.isLoggedIn) {
      this.navigateToPreviousRouteOrProductSelect();
    } else {
      const routeArea = this.$route.params.area;
      if (routeArea && this.areas.includes(routeArea)) {
        this.setArea(routeArea);
      }
    }
  }

  @Getter("systemLoaded", userNamespace)
  systemLoaded!: boolean;
}
